import { useFeatureFlags } from './use-feature-flags';

export function useDisableSpaNavigation() {
  const { DISABLE_SPA_NAVIGATION } = useFeatureFlags() ?? {};

  return { disableSpaNavigation: DISABLE_SPA_NAVIGATION ?? false };
}
